module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "input-demo",
    attrs: {
      "title": "Input"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "size",
      "description": "大小",
      "code": _vm.code
    },
    slot: "left"
  }, [_c('Input', {
    attrs: {
      "size": 'sm'
    },
    model: {
      value: (_vm.size_test),
      callback: function($$v) {
        _vm.size_test = $$v
      },
      expression: "size_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "size": 'md'
    },
    model: {
      value: (_vm.size_test),
      callback: function($$v) {
        _vm.size_test = $$v
      },
      expression: "size_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "size": 'lg'
    },
    model: {
      value: (_vm.size_test),
      callback: function($$v) {
        _vm.size_test = $$v
      },
      expression: "size_test"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.size_test))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "labelFloat",
      "description": "标题浮动",
      "code": _vm.label_code
    },
    slot: "right"
  }, [_c('Input', {
    attrs: {
      "label": '我是浮动标题'
    },
    model: {
      value: (_vm.label_test),
      callback: function($$v) {
        _vm.label_test = $$v
      },
      expression: "label_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": '我是提示'
    },
    model: {
      value: (_vm.label_test),
      callback: function($$v) {
        _vm.label_test = $$v
      },
      expression: "label_test"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "status",
      "description": "状态",
      "code": _vm.disabled_code
    },
    slot: "left"
  }, [_c('Input', {
    attrs: {
      "placeholder": '正常使用'
    },
    model: {
      value: (_vm.status_test),
      callback: function($$v) {
        _vm.status_test = $$v
      },
      expression: "status_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": '我被禁用了',
      "disabled": true
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "color",
      "description": "颜色",
      "code": _vm.color_code
    },
    slot: "right"
  }, [_c('Input', {
    attrs: {
      "placeholder": '默认'
    },
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": '绿色',
      "color": "#4fae9B"
    },
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": '蓝色',
      "color": "rgb(0, 160, 233)"
    },
    model: {
      value: (_vm.color_test),
      callback: function($$v) {
        _vm.color_test = $$v
      },
      expression: "color_test"
    }
  })], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "verify",
      "description": "验证",
      "code": _vm.verify_code
    },
    slot: "left"
  }, [_c('Input', {
    attrs: {
      "placeholder": '验证手机号(数字7~14位)',
      "verify": "phone"
    },
    on: {
      "verify": function($event) {
        _vm.verify_result = arguments[0]
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("手机号验证结果: " + _vm._s(_vm.verify_result))]), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": '验证手机号/邮箱',
      "verify": ['phone', 'email']
    },
    on: {
      "verify": function($event) {
        _vm.verify3_result = arguments[0]
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("手机号/邮箱验证果: " + _vm._s(_vm.verify3_result))]), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": '输入 哈哈',
      "reg": /哈哈/,
      "tip": "不开心"
    },
    on: {
      "verify": function($event) {
        _vm.verify1_result = arguments[0]
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("自定义验证1结果：" + _vm._s(_vm.verify1_result))]), _vm._v(" "), _c('Input', {
    ref: 'verify_input',
    attrs: {
      "placeholder": '自定义验证2'
    },
    on: {
      "verify": function($event) {
        _vm.verify2_result = arguments[0]
      }
    }
  }), _vm._v(" "), _c('p', [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.$refs.verify_input.$emit(_vm.verify2_result ? 'error' : 'correct', '自定义的错误信息啊')
      }
    }
  }, [_vm._v(_vm._s(_vm.verify2_result ? '报错' : '正确'))]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$refs.verify_input.$emit('clear')
      }
    }
  }, [_vm._v("清除(验证结果还原为false)")])], 1), _vm._v(" "), _c('p', [_vm._v("自定义验证1结果：" + _vm._s(_vm.verify2_result))])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "textarea",
      "description": "文本域",
      "code": _vm.textarea_code
    },
    slot: "right"
  }, [_c('Input', {
    model: {
      value: (_vm.textarea_test),
      callback: function($$v) {
        _vm.textarea_test = $$v
      },
      expression: "textarea_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": '默认3行高',
      "type": "textarea"
    },
    model: {
      value: (_vm.textarea_test),
      callback: function($$v) {
        _vm.textarea_test = $$v
      },
      expression: "textarea_test"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "placeholder": '内容撑开高度',
      "autosize": true
    },
    model: {
      value: (_vm.textarea_test),
      callback: function($$v) {
        _vm.textarea_test = $$v
      },
      expression: "textarea_test"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91c061b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Input.vue
// module id = 683
// module chunks = 0